import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import AllApplicationLoading from "../../../Shared/LoaderBigTwo/AllApplicationLoading";

function SuperAdminAllApplicationsTwo() {
  const [allApplications, setAllApplications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [ApplyEmailData, setApplyEmailData] = useState(allApplications);

  const savePageToLocalStorage = (page) => {
    localStorage.setItem("currentPage", page.toString());
  };

  const getPageFromLocalStorage = () => {
    const savedPage = localStorage.getItem("currentPage");
    return savedPage ? parseInt(savedPage) : 1;
  };

  const fetchApplications = async (page) => {
    setLoading(true);
    try {
      const limit = 18;
      const response = await fetch(
        `https://tutor-tree-server-1.vercel.app/PublishMainDataStreamPagination?page=${page}&limit=${limit}`
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      setAllApplications(data.data);
      setApplyEmailData(data.data);
      setTotalPages(Math.ceil(data.total / limit));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoading(false);
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    savePageToLocalStorage(newPage);
  };

  useEffect(() => {
    fetchApplications(currentPage);
  }, [currentPage]);

  useEffect(() => {
    const savedPage = getPageFromLocalStorage();
    setCurrentPage(savedPage);
  }, []);

  //   TOTAL DATA
  // const [GrayColor, setGrayColor] = useState([]);

  // const fetchGray = async () => {
  //   try {
  //     const response = await fetch('https://tutor-tree-server-1.vercel.app/grayColor');
  //     if (!response.ok) {
  //       throw new Error('Failed to fetch data');
  //     }
  //     const data = await response.json();

  //     // Debugging statements
  //     console.log('Fetched data:', data);
  //     console.log('Reversed data:', data.reverse());

  //     setGrayColor(data.reverse());

  //   } catch (error) {
  //     console.error('Error fetching data:', error);

  //   }
  // };

  // useEffect(() => {
  //   fetchGray();
  // }, []);

  const classMapping = {
    "Pre-Schooling": "Pre-Schooling",
    Play: "Play",
    Nursery: "Nursery",
    KG: "KG",
    BM1: "Class 1",
    BM2: "Class 2",
    BM3: "Class 3",
    BM4: "Class 4",
    BM5: "Class 5",
    BM6: "Class 6",
    BM7: "Class 7",
    BM8: "Class 8",
    BM9: "Class 9",
    BM10: "Class 10",
    "BMHSC-1stYear": "HSC-1st Year",
    "BMHSC-2stYear": "HSC-2nd Year",
    EV1: "Class 1",
    EV2: "Class 2",
    EV3: "Class 3",
    EV4: "Class 4",
    EV5: "Class 5",
    EV6: "Class 6",
    EV7: "Class 7",
    EV8: "Class 8",
    EV9: "Class 9",
    EV10: "Class 10",
    "EVHSC-1stYear": "HSC-1st Year",
    "EVHSC-2stYear": "HSC-2nd Year",
    EM1: "Class 1",
    EM2: "Class 2",
    EM3: "Class 3",
    EM4: "Class 4",
    EM5: "Class 5",
    EM6: "Class 6",
    EM7: "Class 7",
    EM8: "Class 8",
    EM9: "Class 9",
    OLevel: "OLevel",
    ALevelAS: "A Level (AS)",
    ALevelA2: "A Level (A2)",
    "EMHSC-2stYear": "HSC-2nd Year",
    Alim1: "Class 1",
    Alim2: "Class 2",
    Alim3: "Class 3",
    Alim4: "Class 4",
    Alim5: "Class 5",
    Alim6: "Class 6",
    Alim7: "Class 7",
    Alim8: "Class 8",
    Alim9: "Class 9",
    Alim10: "Class 10",
    "Alim-1stYear": "Alim-1st Year",
    "Alim-2stYear": "Alim-2nd Year",
    IslamicStudies: "Islamic Studies",
    HinduismStudies: "Hinduism Studies",
    BuddhismStudies: "Buddhism Studies",
    ChristianityStudies: "Christianity Studies",
    SchoolAdmissionTest: "School Admission Test",
    PublicUniversityAdmissionTest: "Public University Admission Test",
    PrivateUniversityAdmissionTest: "Private University Admission Test",
    MedicalCollegeAdmissionTest: "Medical College Admission Test",
    EngineeringUniversityAdmissionTest: "Engineering University Admission Test",
    Arts: "Arts",
    Music: "Music",
    InstrumentalMusic: "Instrumental Music",
    Dance: "Dance",
    Crafting: "Crafting",
    Recitation: "Recitation",
    TestPreparation: "Test Preparation",
    IELTS: "IELTS",
    TOEFL: "TOEFL",
    GRE: "GRE",
    GMAT: "GMAT",
    SAT: "SAT",
    GED: "GED",
  };

  // EMAIL FILTER DATA START

  const [allAdminEmail, setAllAdminEmail] = useState("");

  const handleAdminClickAllButton = (email) => {
    setAllAdminEmail(email.toString());
  };

  console.log("allAdmin", allAdminEmail);

  useEffect(() => {
    if (allAdminEmail) {
      const filteredData = allApplications.filter(
        (application) => application.assignEmail === allAdminEmail
      );
      setApplyEmailData(filteredData);
    } else {
      setApplyEmailData(allApplications);
    }
  }, [allAdminEmail, allApplications]);

  const [AllAdmin, setAllAdmin] = useState([]);

  const fetchAllAdmin = async () => {
    try {
      const response = await fetch("https://tutor-tree-server-1.vercel.app/AdminMainData");
      const data = await response.json();
      setAllAdmin(data);
    } catch (error) {
      console.error("Error fetching Admins:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllAdmin();
  }, []);

  const handleClear = () => {
    setApplyEmailData(allApplications);
    setAllAdminEmail("");
  };

  // EMAIL FILTER DATA END

  return (
    <div>
      <div className="w-full h-32 flex justify-center items-center bg-gray-50">
        <h2 className="headingTxt">All Applications </h2>
      </div>
      {loading ? (
        <AllApplicationLoading className="mt-5"></AllApplicationLoading>
      ) : (
        <ApplicationList
          handleClear={handleClear}
          ApplyEmailData={ApplyEmailData}
          applications={allApplications}
          classMapping={classMapping}
          AllAdmin={AllAdmin}
          handleAdminClickAllButton={handleAdminClickAllButton}
        />
      )}
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
    </div>
  );
}

function ApplicationList({
  applications,
  ApplyEmailData,
  handleClear,
  classMapping,
  AllAdmin,
  handleAdminClickAllButton,
}) {
  return (
    <div className="mt-5 mx-10">
      <div className="flex flex-row-end my-5 ">
        <button className="dropdown">
          <summary className="py-2 px-3 rounded-md focus:bg-orange-300 btnSelectAdmin bg-orange-100 mt-2  flex justify-center items-center">
            All
          </summary>
          <ul className="p-2 w-56 mt-3  shadow drpArea menu h-56 overflow-auto scrollbar overflow-x-hidden dropdown-content z-[1] bg-base-100 rounded-box">
            {AllAdmin.map((admin) => (
              <button
                key={admin.email}
                className="w-full my-1 py-1 px-2 rounded-md textBtnOne mx-1 bg-orange-400 hover:bg-orange-500 focus:bg-orange-500"
                onClick={() => handleAdminClickAllButton(admin.email)}
              >
                {admin.email}
              </button>
            ))}
          </ul>
        </button>
        <button
          className="btnClear flex ml-5 w-8 h-12 mt-handleAdminClickAllButton2 justify-center items-center"
          onClick={handleClear}
        >
          clear
        </button>
      </div>
      <div className="grid grid-cols-4 place-items-center gap-5">
        {ApplyEmailData.map((application, index) => (
          <div
            className={`w-full border-2 rounded-xl p-5  hover:rounded-xl  ${
              application.grayColorMatch === true
                ? "border-gray-200 border-4"
                : "border-orange-500 "
            }`}
            key={index}
          >
            <Link
              to={`/dashboardTwo/AdminAllApplicationDetails/${application._id}`}
            >
              <h1 className="AppliTextCard1">
                {classMapping[application.class] || application.class} |{" "}
                {application.category}
              </h1>

              <div className="mt-5 flex-col justify-between ">
                <div className="flex justify-start items-center flex-row">
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="15"
                      viewBox="0 0 13 15"
                      fill="none"
                    >
                      <path
                        d="M10.5301 14.5001H1.58594C0.710938 14.4973 0.00273437 13.7891 0 12.9141V12.2141C0 10.5024 0.719141 8.86999 1.98516 7.71882C2.51289 7.24031 3.29766 7.17468 3.89648 7.56023C4.52266 7.96218 5.26914 8.17546 6.05938 8.17546C6.84961 8.17546 7.59609 7.96218 8.22227 7.56023C8.82109 7.17468 9.60586 7.24031 10.1336 7.71882C11.3996 8.86999 12.1215 10.5024 12.1188 12.2141V12.9141C12.116 13.7919 11.4051 14.5001 10.5301 14.5001ZM3.04336 7.85554C2.78633 7.85554 2.54023 7.95124 2.35156 8.12351C1.20039 9.17078 0.544141 10.6583 0.544141 12.2141V12.9141C0.546875 13.4884 1.00898 13.9505 1.5832 13.9532H10.5273C11.1016 13.9532 11.5664 13.4884 11.5664 12.9141V12.2141C11.5664 10.6583 10.9102 9.17351 9.75898 8.12351C9.41445 7.81179 8.90313 7.76804 8.51211 8.0196C7.79844 8.47898 6.94805 8.72234 6.05391 8.72234C5.15977 8.72234 4.30937 8.47898 3.5957 8.0196C3.43438 7.91296 3.24023 7.85554 3.04336 7.85554Z"
                        fill="#A4A4A4"
                      />
                      <path
                        d="M6.05939 7.55469C4.11251 7.55195 2.53478 5.97422 2.53204 4.02734C2.53204 2.0832 4.11251 0.5 6.05939 0.5C8.00626 0.502734 9.584 2.08047 9.58673 4.02734C9.584 5.97148 8.00353 7.55469 6.05939 7.55469ZM6.05939 1.04961C4.41329 1.04961 3.07892 2.38398 3.07892 4.03008C3.07892 5.67617 4.41329 7.01055 6.05939 7.01055C7.70548 7.01055 9.03986 5.67617 9.03986 4.03008C9.03712 2.38398 7.70548 1.04961 6.05939 1.04961Z"
                        fill="#A4A4A4"
                      />
                    </svg>
                  </div>
                  <div className="ml-3">
                    <h1 className="textMiddleAppli">{application.jobId}</h1>
                  </div>
                </div>
                <div className="flex justify-start items-center flex-row mt-5">
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="15"
                      viewBox="0 0 14 15"
                      fill="none"
                    >
                      <path
                        d="M3.41197 0.560635C3.54613 0.688085 3.61147 0.77374 3.67118 0.95285C3.67118 1.14193 3.67118 1.33101 3.67118 1.52583C5.70606 1.52583 7.74094 1.52583 9.83748 1.52583C9.83748 1.33674 9.83748 1.14766 9.83748 0.95285C9.92968 0.706972 9.92968 0.706972 10.0302 0.627141C10.0491 0.611701 10.0679 0.596261 10.0874 0.580352C10.2228 0.481159 10.3855 0.502432 10.5469 0.516298C10.6811 0.558744 10.7703 0.645406 10.847 0.761858C10.8941 0.861609 10.9081 0.938897 10.9069 1.04888C10.9067 1.07675 10.9066 1.10463 10.9064 1.13334C10.9059 1.16213 10.9055 1.19092 10.905 1.22058C10.9047 1.24989 10.9045 1.27921 10.9042 1.30941C10.9036 1.38156 10.9027 1.45369 10.9016 1.52583C10.9234 1.52554 10.9452 1.52525 10.9677 1.52496C11.7132 1.51648 12.3658 1.52618 12.9411 2.06555C13.2597 2.37972 13.4777 2.79021 13.4971 3.24501C13.4972 3.27422 13.4972 3.30342 13.4973 3.33352C13.4974 3.36741 13.4975 3.4013 13.4976 3.43622C13.4976 3.47361 13.4976 3.51101 13.4976 3.5484C13.4977 3.5883 13.4978 3.62819 13.4979 3.66809C13.4982 3.77762 13.4983 3.88715 13.4984 3.99669C13.4985 4.11487 13.4987 4.23306 13.499 4.35124C13.4995 4.63663 13.4998 4.92201 13.5 5.2074C13.5002 5.34192 13.5003 5.47643 13.5004 5.61095C13.5009 6.05833 13.5013 6.50571 13.5015 6.95309C13.5016 7.06914 13.5016 7.18518 13.5017 7.30123C13.5017 7.33007 13.5017 7.35891 13.5017 7.38863C13.5019 7.85553 13.5026 8.32242 13.5035 8.78932C13.5044 9.26907 13.5049 9.74882 13.505 10.2286C13.505 10.4978 13.5053 10.767 13.506 11.0362C13.5066 11.2655 13.5068 11.4948 13.5065 11.7242C13.5064 11.841 13.5064 11.9579 13.507 12.0748C13.5075 12.1821 13.5074 12.2893 13.507 12.3966C13.5069 12.4352 13.5071 12.4737 13.5074 12.5122C13.5116 13.0478 13.3605 13.5091 13.0025 13.913C12.988 13.9301 12.9735 13.9471 12.9586 13.9647C12.686 14.2636 12.2517 14.4681 11.8482 14.4911C11.7381 14.4932 11.6281 14.4935 11.518 14.4933C11.4753 14.4934 11.4326 14.4935 11.3899 14.4936C11.2731 14.494 11.1562 14.494 11.0393 14.4939C10.9131 14.4939 10.7869 14.4942 10.6607 14.4945C10.4135 14.4949 10.1664 14.4951 9.91928 14.4951C9.71831 14.4951 9.51734 14.4952 9.31637 14.4954C8.74615 14.4959 8.17593 14.4961 7.60571 14.4961C7.57498 14.4961 7.54426 14.4961 7.51261 14.4961C7.46646 14.4961 7.46646 14.4961 7.41939 14.4961C6.92107 14.4961 6.42276 14.4966 5.92444 14.4973C5.41235 14.4981 4.90025 14.4985 4.38815 14.4985C4.10082 14.4984 3.8135 14.4986 3.52617 14.4992C3.28149 14.4997 3.03681 14.4998 2.79213 14.4994C2.66742 14.4992 2.5427 14.4992 2.41799 14.4997C2.30357 14.5001 2.18916 14.5001 2.07474 14.4996C2.03359 14.4995 1.99244 14.4996 1.9513 14.4999C1.41546 14.5036 0.959135 14.3526 0.567348 13.9768C0.151863 13.5433 -0.00294684 13.05 0.00119064 12.4579C0.00106449 12.4177 0.000890978 12.3776 0.000674811 12.3375C0.000224189 12.2286 0.000442082 12.1196 0.000782432 12.0107C0.00103132 11.8927 0.000647177 11.7747 0.000347993 11.6567C-0.00013533 11.4261 -3.33762e-05 11.1955 0.000283878 10.9649C0.000531135 10.7774 0.000563456 10.5898 0.000444997 10.4022C0.000428274 10.3755 0.000411644 10.3487 0.000394413 10.3211C0.000359517 10.2667 0.000324115 10.2123 0.00028825 10.1579C-2.23844e-05 9.64872 0.000333943 9.13953 0.000921278 8.63034C0.00140883 8.19416 0.00132405 7.75799 0.000820942 7.32181C0.000235866 6.81435 7.60057e-06 6.30688 0.000342164 5.79941C0.000376927 5.74522 0.000411146 5.69103 0.000444997 5.63683C0.000461835 5.61018 0.00047865 5.58352 0.000495998 5.55605C0.000589924 5.36889 0.000431859 5.18173 0.000174384 4.99457C-0.000132845 4.76624 -4.65209e-05 4.53792 0.000532426 4.30959C0.000817731 4.19327 0.000934207 4.07695 0.000570729 3.96063C0.00024215 3.85386 0.000429608 3.74709 0.00100475 3.64032C0.00112525 3.60199 0.00106797 3.56365 0.000800126 3.52532C-0.00294182 2.94463 0.183511 2.46448 0.581203 2.04082C1.0437 1.59344 1.61594 1.52017 2.22851 1.52412C2.26538 1.52426 2.30226 1.52438 2.33914 1.52449C2.42845 1.52481 2.51777 1.52526 2.60708 1.52583C2.60622 1.49902 2.60622 1.49902 2.60535 1.47168C2.60306 1.38969 2.60165 1.30771 2.60026 1.2257C2.59934 1.19759 2.59843 1.16949 2.59749 1.14054C2.59498 0.943556 2.61645 0.784531 2.7567 0.637593C2.93493 0.481464 3.19883 0.461674 3.41197 0.560635ZM1.27014 2.86277C0.828669 3.42189 1.07915 4.29816 1.07915 4.90911C4.82477 4.90911 8.57038 4.90911 12.4295 4.90911C12.561 3.87813 12.561 3.87813 12.2047 2.82269C11.932 2.58564 11.6281 2.58212 11.2836 2.58651C11.2464 2.58679 11.2093 2.58703 11.1722 2.58726C11.082 2.5879 10.9918 2.58879 10.9016 2.58992C10.9012 2.61796 10.9012 2.61796 10.9008 2.64657C10.8993 2.7323 10.897 2.81798 10.8948 2.90369C10.8944 2.9331 10.894 2.9625 10.8936 2.99279C10.8879 3.17891 10.8657 3.30496 10.7652 3.46303C10.5916 3.60117 10.4355 3.62121 10.2195 3.59945C10.0867 3.55481 9.99453 3.47086 9.91933 3.35389C9.86476 3.19018 9.86476 3.19018 9.83748 2.58992C7.8026 2.58992 5.76772 2.58992 3.67118 2.58992C3.66217 2.78801 3.65317 2.98609 3.64389 3.19018C3.55154 3.43645 3.55154 3.43645 3.46654 3.50225C3.4505 3.51516 3.43447 3.52806 3.41794 3.54136C3.28963 3.62564 3.13621 3.61372 2.98906 3.59945C2.86078 3.56228 2.78753 3.51135 2.70428 3.40675C2.64612 3.29741 2.63026 3.21571 2.62573 3.09351C2.62459 3.06423 2.62344 3.03495 2.62227 3.00478C2.62119 2.97424 2.62012 2.94369 2.61902 2.91222C2.61784 2.88136 2.61666 2.85049 2.61545 2.8187C2.61255 2.74244 2.60977 2.66618 2.60708 2.58992C2.49989 2.58787 2.39271 2.5864 2.28551 2.58543C2.23149 2.58482 2.17748 2.58378 2.12347 2.58273C1.78794 2.58018 1.51346 2.61699 1.27014 2.86277ZM1.07915 5.9732C1.07689 7.09306 1.07464 8.21292 1.07232 9.36671C1.07133 9.72034 1.07034 10.074 1.06931 10.4383C1.06895 10.7552 1.06895 10.7552 1.06873 11.0722C1.06863 11.2134 1.06823 11.3545 1.06762 11.4957C1.06685 11.6759 1.06665 11.856 1.06681 12.0362C1.06677 12.1023 1.06656 12.1684 1.06613 12.2344C1.06559 12.3238 1.06572 12.4132 1.06602 12.5026C1.0657 12.5283 1.06539 12.554 1.06506 12.5806C1.067 12.7982 1.1273 12.9739 1.24626 13.1559C1.53967 13.4365 1.85574 13.4574 2.24389 13.4561C2.28444 13.4562 2.32499 13.4562 2.36554 13.4563C2.47651 13.4566 2.58747 13.4565 2.69843 13.4563C2.81828 13.4562 2.93814 13.4564 3.05799 13.4565C3.29259 13.4568 3.5272 13.4567 3.7618 13.4565C3.9525 13.4564 4.14319 13.4564 4.33389 13.4565C4.36105 13.4565 4.3882 13.4565 4.41618 13.4565C4.47135 13.4565 4.52652 13.4565 4.58169 13.4565C5.09884 13.4567 5.61599 13.4565 6.13314 13.4562C6.57673 13.456 7.02032 13.456 7.46391 13.4563C7.97923 13.4566 8.49455 13.4567 9.00987 13.4565C9.06483 13.4565 9.1198 13.4565 9.17477 13.4565C9.20181 13.4565 9.22885 13.4564 9.25671 13.4564C9.44715 13.4564 9.63758 13.4565 9.82801 13.4566C10.0601 13.4568 10.2923 13.4567 10.5244 13.4564C10.6428 13.4563 10.7612 13.4562 10.8796 13.4564C10.988 13.4566 11.0965 13.4565 11.2049 13.4562C11.2441 13.4561 11.2832 13.4562 11.3224 13.4563C11.6487 13.4573 11.9175 13.4357 12.1839 13.2309C12.363 13.0488 12.4384 12.8397 12.4401 12.5876C12.4397 12.5488 12.4397 12.5488 12.4394 12.5091C12.4395 12.4672 12.4395 12.4672 12.4396 12.4244C12.4397 12.3307 12.4392 12.2371 12.4388 12.1434C12.4388 12.0751 12.4388 12.0068 12.4388 11.9384C12.4388 11.7742 12.4385 11.6099 12.438 11.4456C12.4374 11.2555 12.4373 11.0654 12.4373 10.8752C12.4368 10.3735 12.4357 9.87182 12.4346 9.37013C12.4321 7.68865 12.4321 7.68865 12.4295 5.9732C8.68389 5.9732 4.93827 5.9732 1.07915 5.9732Z"
                        fill="#A4A4A4"
                      />
                    </svg>
                  </div>
                  <div className="ml-3">
                    <h1 className="textMiddleAppli">
                      {new Date(application.postedDate).toLocaleDateString(
                        "en-GB"
                      )}
                    </h1>
                  </div>
                </div>
                <div className="flex justify-start items-center flex-row mt-5">
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="15"
                      viewBox="0 0 14 15"
                      fill="none"
                    >
                      <path
                        d="M13.07 0.500001H0.588281C0.368136 0.499585 0.166314 0.622566 0.0656805 0.818419C-0.0363411 1.01691 -0.0184352 1.25593 0.111903 1.43721L4.68469 7.87887C4.68622 7.88109 4.68788 7.88317 4.68941 7.88539C4.85556 8.1097 4.94537 8.38134 4.94592 8.66062V13.9124C4.94495 14.068 5.00602 14.2174 5.11568 14.3277C5.22534 14.4381 5.37441 14.5 5.52987 14.5C5.60899 14.5 5.68714 14.4842 5.76015 14.4539L8.32971 13.4741C8.55998 13.4039 8.71281 13.1866 8.71281 12.925V8.66062C8.71323 8.38148 8.80317 8.1097 8.96918 7.88539C8.97071 7.88317 8.97237 7.88109 8.9739 7.87887L13.5465 1.43693C13.6769 1.25579 13.6948 1.01691 13.5928 0.818419C13.4921 0.622566 13.2903 0.499585 13.07 0.500001ZM8.39619 7.4644C8.14079 7.81099 8.00268 8.23004 8.00185 8.66062V12.8386L5.6566 13.7328V8.66062C5.65577 8.23004 5.51766 7.81099 5.26212 7.4644L0.822722 1.21068H12.8357L8.39619 7.4644Z"
                        fill="#A4A4A4"
                      />
                    </svg>
                  </div>
                  <div className="ml-3">
                    <h1 className="cardFilterAppli">
                      {application.TotalMatchData}
                    </h1>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>

    </div>
  );
}

function Pagination({ currentPage, totalPages, onPageChange }) {
  const maxPageNumbersToShow = 5;
  let startPage, endPage;

  if (totalPages <= maxPageNumbersToShow) {
    startPage = 1;
    endPage = totalPages;
  } else {
    const maxPagesBeforeCurrentPage = Math.floor(maxPageNumbersToShow / 2);
    const maxPagesAfterCurrentPage = Math.ceil(maxPageNumbersToShow / 2) - 1;
    if (currentPage <= maxPagesBeforeCurrentPage) {
      startPage = 1;
      endPage = maxPageNumbersToShow;
    } else if (currentPage + maxPagesAfterCurrentPage >= totalPages) {
      startPage = totalPages - maxPageNumbersToShow + 1;
      endPage = totalPages;
    } else {
      startPage = currentPage - maxPagesBeforeCurrentPage;
      endPage = currentPage + maxPagesAfterCurrentPage;
    }
  }

  const pages = Array.from(
    { length: endPage + 1 - startPage },
    (_, i) => startPage + i
  );

  return (
    <div className="flex justify-center items-center mt-5">
      <nav aria-label="Page navigation example">
        <ul className="inline-flex -space-x-px text-sm">
          <li>
            <button
              onClick={() => onPageChange(currentPage - 1)}
              disabled={currentPage <= 1}
              className="flex items-center rounded-l-md  justify-center px-3 h-8 ms-0 leading-tight text-gray-500 bg-white border border-e-0 border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
            >
              Previous
            </button>
          </li>
          {pages.map((page) => (
            <li key={page}>
              <button
                onClick={() => onPageChange(page)}
                className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white ${
                  currentPage === page
                    ? "text-blue-600 border border-gray-300 bg-blue-50 hover:bg-blue-100 hover:text-blue-700 dark:border-gray-700 dark:bg-gray-700 dark:text-white"
                    : ""
                }`}
              >
                {page}
              </button>
            </li>
          ))}
          <li>
            <button
              onClick={() => onPageChange(currentPage + 1)}
              disabled={currentPage >= totalPages}
              className="flex items-center rounded-r-md mx-2 justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
            >
              Next
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
}

export default SuperAdminAllApplicationsTwo;
